module.exports = __webpack_public_path__ + "assets/img/three_phone.9f138944.png";